export default "__VITE_ASSET__BYuqqGBm__"